export const ACTION_CREATE_LOT = 'createLot';
export const ACTION_ASSOCIATE_LOT = 'associerLot';
export const ACTION_GENERATION_ECRITURE = 'generationEcriture';
